// reloadPricingProfileList.epic.ts
import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PricingProfileAction } from '@cbridge-packages/pricing-profile';

export const reloadPricingProfileListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PricingProfileAction.create.done,
    PricingProfileAction.update.done,
    PricingProfileAction.remove.done,
  ),
  map(() => {
    return PricingProfileAction.loadList.started();
  }),
);
